import { newDateFromUTC, newDateToUTC } from '@bc-library/common'
import { date } from 'yup';


// DATA RECEIVED FOM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
     return afterReceivingOne(object);
   })
  }
  else if(data.docs && data.count && Array.isArray(data.docs)){
    data.docs = data.docs.map((object:any) => {
      return afterReceivingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = afterReceivingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const afterReceivingOne = (object:any) => {
  if(typeof object == 'object'){
    return {
      ...object,
      date: object.date ? newDateFromUTC(object.date) : object.date
    }
  }
  return object;
}

// OBJECT FIELDS






// DATA TO BE SENT TO API (TO UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const beforeSending = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
      return beforeSendingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const beforeSendingOne = (object:any) => {
  if(typeof object == 'object'){
    return {
      ...object,
      date: object.date ? newDateToUTC(object.date) : object.date
    }
  }
  return object;
}

// OBJECT FIELDS
